angular.module('picmonic-common').controller('RTSourcingModalController', [
  '$scope',
  'UserService',
  'PresentationsResource',
  function ($scope, UserService, PresentationsResource) {
    $scope.loading = false;
    $scope.UserService = UserService;
    $scope.step = 1;

    $scope.dates = [];
    for (var i = 1; i <= 180; i++) {
      var date = new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * (i + 2));
      if (date.getDay() >= 1 && date.getDay() <= 5) {
        $scope.dates.push(date);
      }
    }

    $scope.setStep = function (step) {
      $scope.step = step;
    };

    $scope.save = function () {
      if (!$scope.loading) {
        $scope.loading = true;
        PresentationsResource.save($scope.contact, function () {
          $scope.completed = true;
          send_ga('event', 'Presentations', 'Presentation Scheduled');
        }).$promise.finally(function () {
          $scope.loading = false;
        });
      }
    };
  },
]);
